import React from 'react';
import '../App.css';

export const Unavailable = () => {

    return (
		<div className="fullscreen-container">
			<h1>This page is being worked on, sorry!</h1>
		</div>
    );
};
 
